// extracted by mini-css-extract-plugin
module.exports = {"tab":"EntityMain_tab__2vFUY","tabContent":"EntityMain_tabContent__3iyU5"};